export default {
    setLoading(state, loading) {
        state.loading = loading;
    },
    setCatalogs(state, catalogs) {
        state.catalogs = catalogs.data;
        state.total = catalogs.total;
        state.loaded = true;
    },
}